module.exports = __webpack_public_path__ + "static/media/star_pol-y_90.4d60a82c.png";